<template>
<div>
    <v-menu v-model='menu' :close-on-content-click="false" offset-x dark >
        <template v-slot:activator='{ on, attrs }'>
            <v-btn icon dark v-bind='attrs' v-on='on' class='mr-n2'>
                <v-icon large>mdi-plus</v-icon>
            </v-btn>
        </template>
        <v-card width='650'>
            <v-tabs fixed-tabs>
                <v-tab>Add Rinble User</v-tab>
                <v-tab>Add SMS Contact</v-tab>
                <v-tab>Create New Group</v-tab>
                <v-tab-item>
                <v-card tile height='263'>
                    <v-card-title>Add Rinble User</v-card-title>
                    <v-card-subtitle>Existing Rinble users can be added by their e-mail address.</v-card-subtitle>
                    <v-card-text>
                    <div class="form-group has-success">
                        <label class="control-label" for="fnameTxt">Email</label>
                        <input id="emailTxt" type="text" v-model="email" class="form-control" />
                        <span class="help-block">{{emailErrorTxt}}</span>
                    </div>

                    <div class="form-group">
                        <v-btn class="btn btn-primary" :loading='addLoading' @click="addEmailContact(); addLoading=true;">Add</v-btn>
                        &nbsp;
                        <v-btn class="btn btn-info" @click="menu=false">Cancel</v-btn>
                    </div>
                    </v-card-text>
                </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card tile height='263'>
                        <v-card-title>Add SMS Contact</v-card-title>
                        <v-card-subtitle>Enter sending number, contact name and contact number.</v-card-subtitle>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <div class="form-group has-success">
                                        <label class="control-label" for="fnameTxt">From</label>
                                        <select class="form-control" v-model="fromNumber">
                                        <option v-for="smsFromNumber in smsFromNumbers" v-bind:value="smsFromNumber.number" v-bind:key='smsFromNumber.number'>{{smsFromNumber.number}} - {{smsFromNumber.entity_name}}</option>
                                        </select>
                                    </div>
                                </v-col>
                                <v-col>
                                    <div class="form-group has-success">
                                        <label class="control-label" for="fnameTxt">Name</label>
                                        <input id="fnameTxt" type="text" v-model="name" class="form-control">
                                    </div>
                                </v-col>
                                <v-col>
                                    <div class="form-group has-success">
                                        <label class="control-label" for="numberTxt">Phone Number</label>
                                        <TheMask id="numberTxt" mask="+1 (###) ###-####" type="text" v-model="number" class="form-control" />
                                    </div>
                                </v-col>
                            </v-row>

                            <div class="form-group">
                            <v-btn class="btn btn-primary" :loading='addLoading' @click="addSMSContact(name, number, fromNumber); addLoading=true;">Add</v-btn>
                            &nbsp;
                            <v-btn class="btn btn-info" @click="menu=false">Cancel</v-btn>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card tile height='263'>
                        <v-card-title>Create new group</v-card-title>
                        <v-card-subtitle>Use a group to chat among multiple users. Users can be added in the "Members" menu. For SMS, use the admin portal to connect the group to a phone number.</v-card-subtitle>
                        <v-card-text>
                            <div class="form-group has-success">
                                <label class="control-label" for="groupNameTxt">Group Name</label>
                                <input id="groupNameTxt" type="text" v-model="groupName" class="form-control">
                            </div>

                            <div class="form-group">
                            <v-btn class="btn btn-primary" :loading='addLoading' @click="createGroup(groupName); addLoading=true;">Create</v-btn>
                            &nbsp;
                            <v-btn class="btn btn-info" @click="menu=false">Cancel</v-btn>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </v-card>
    </v-menu>
</div>
</template>

<script >




  let addEmailContactMutationTxt = `
    mutation addEmailContactMutation($input: AddEmailContactInput) {
      addEmailContact(input: $input) {
        message_id
        to_id
        to_type
        from_id
        from_type
        text
        dated
        msg_group_id
        fromName
        toName
        groupBy
      }
    }
  `;
  
let addSMSContactMutationTxt = `
    mutation addSMSContactMutation($input: AddSMSContactInput) {
      addSMSContact(input: $input) {
        message_id
        to_id
        to_type
        from_id
        from_type
        text
        dated
        msg_group_id
        fromName
        toName
        groupBy
      }
    }
  `;

  let addMsgGroupMutationTxt = `
    mutation addMsgGroup($input: MsgGroupInput) {
      addMsgGroup(input: $input) {
        message_id
        to_id
        to_type
        from_id
        from_type
        text
        dated
        msg_group_id
        fromName
        toName
        groupBy
      }
    }
  `;


import {TheMask} from 'vue-the-mask';
import ChatCommon from '../mixins/chatcommon';

export default {
  props: [

  ],
  mixins: [ChatCommon],
  computed: {
    smsFromNumbers: {
      get() {
        return this.$store.state.smsFromNumbers;
      }
    }
  },
  components: {
    TheMask,
  },
  data () {
    return {
      menu: false,
      isEmail: true,
      name: '',
      groupName: '',
      email: '',
      number: '',
      fromNumber: '',
      emailErrorTxt: '',
      addLoading: false,
    }
  },
  watch: {
   // pMsgGroupId() { this.remote_user = Meteor.users.find({ _id: this.remoteuid }).fetch()[0] },
  },
  methods: {
    debug: function(e) {
      console.log('debug: ', e);
    },
    addEmailContact: function() {
      let self = this;
      let msgGroupId = null;
      
      let variables = {
        input: {
            name: this.name,
            email: this.email,
        }
      };
      const gqlClient = global.gqlClient();
      gqlClient.request(addEmailContactMutationTxt, variables).then(function(result) {
        let m = result.addEmailContact;
        if (m.message_id != -1) {
          
          console.log('message');
          console.log('result:', result);
          msgGroupId = m.msg_group_id;
          self.$store.commit('messageAdd', m);
          
        } else {
          self.emailErrorTxt = m.text;
          self.addLoading = false;
        }
        
      }).then(function() {

        if (msgGroupId) {
          // message group permissions for subscriptions are 
          // determined at the server level and are 
          // determined at the time of the initial subscription. If we are
          // adding a group, we need to resubscribe to get the server
          // to re-think the message groups the subscription should 
          // deliver to.
          self.$store.dispatch('resubscribeToMessages');

          // also, we got a message for the group which 
          // will dynamically create the group. But it doesn't
          // have info like MsgGroupMembers. So lets pull down the
          // latest set of groups from the server
          self.$store.dispatch('getMsgGroups');
          self.addLoading=false;
          self.menu =false;
        }
      });

    },
    addSMSContact: function(name, number, fromNumber) {
      let self = this;
      let msgGroupId = null;
      
      let variables = {
        input: {
            name: name,
            number: number,
            fromNumber: fromNumber,
        }
      };
      console.log('adding SMS Contact');
      const gqlClient = global.gqlClient();
      gqlClient.request(addSMSContactMutationTxt, variables).then(function(result) {
        let m = result.addSMSContact;
        //console.log('message');
        //console.log(result);
        self.$store.commit('messageAdd', m);
        msgGroupId = m.msg_group_id;
      }).then(function() {
        // message group permissions for subscriptions are 
        // determined at the server level and are 
        // determined at the time of the initial subscription. If we are
        // adding a group, we need to resubscribe to get the server
        // to re-think the message groups the subscription should 
        // deliver to.
        self.$store.dispatch('resubscribeToMessages');

        // also, we got a message for the group which 
        // will dynamically create the group. But it doesn't
        // have info like MsgGroupMembers. So lets pull down the
        // latest set of groups from the server
        self.$store.dispatch('getMsgGroups');

        // close this form.
        self.addLoading=false;
        self.menu=false;
        console.log('added SMS Contact');
      });

    },
    createGroup: function() {
      let self = this;
      let msgGroupId = null;
      
      let variables = {
        input: {
            name: this.groupName,
        }
      };
      const gqlClient = global.gqlClient();
      gqlClient.request(addMsgGroupMutationTxt, variables).then(function(result) {
        let m = result.addMsgGroup;
        console.log('createGroup');
        console.log(m);
        if (m.message_id != -1) {
          
          //console.log('message');
          //console.log(result);
          msgGroupId = m.msg_group_id;
          console.log('groupAdd: return message');
          console.log(m);
          self.$store.commit('messageAdd', m);
          
        } else {
          self.emailErrorTxt = m.text;
        }
        
      }).then(function() {

        if (msgGroupId) {
          // message group permissions for subscriptions are 
          // determined at the server level and are 
          // determined at the time of the initial subscription. If we are
          // adding a group, we need to resubscribe to get the server
          // to re-think the message groups the subscription should 
          // deliver to.
          self.$store.dispatch('resubscribeToMessages');

          // also, we got a message for the group which 
          // will dynamically create the group. But it doesn't
          // have info like MsgGroupMembers. So lets pull down the
          // latest set of groups from the server
          self.$store.dispatch('getMsgGroups');
          self.addLoading=false;
          self.menu=false;
        }
      });

    },
    closeNewContact: function() {
      this.$emit('closenewcontact');
    }
  },
  mounted() {
    if (this.$store.state.smsFromNumbers[0]) {
      this.fromNumber = this.$store.state.smsFromNumbers[0].number;
      console.log('smsFromNumber exists');
    }
    else {
      console.log('smsFromNumber does not exist');
    }
  }
}
</script>


<style  lang='scss' scoped>


.nav {
  position: relative;
}

/*--------------------
Chat Title
--------------------*/
.chat-title {
  flex: 0 1 45px;
  position: relative;
  z-index: 2;
  height: 45px;
  text-transform: uppercase;
  text-align: left;
  padding: 10px 10px 10px 50px;

  h1, h2 {
    font-weight: normal;
    font-size: 12px;
    margin: 0;
    padding: 0;
  }

  h2 {
    color: #aaa;
    font-size: 10px;
    letter-spacing: 1px;
  }

  .avatar {
    position: absolute;
    z-index: 1;
    top: 8px;
    left: 9px;
    border-radius: 30px;
    width: 30px;
    height: 30px;
    overflow: hidden;
    margin: 0;
    padding: 0;
    border: 2px solid rgba(255, 255, 255, 0.24);

    img {
      width: 100%;
      height: auto;
    }
  }
}
</style>
